import Vue from 'vue'
import Router from 'vue-router'

import menu from './menu'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      name: 'Home',
      path: '/',
      component: require('../views/Home'),
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'Occurrence',
      path: '/occurrences/occurrence/:id',
      component: require('../views/occurrences/Occurrence.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'Occurrence Generic',
      path: '/occurrences/occurrence/generic/:id',
      component: require('../views/occurrences/OccurrenceGeneric.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'Service',
      path: '/services/service/:id',
      component: require('../views/services/Service.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'BookingMissing',
      path: '/services/bookings_missing',
      component: require('../views/services/BookingsMissing.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      name: 'Account Sub',
      path: '/finances/account/:id',
      component: require('../views/finances/AccountsSub.vue'),
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   name: 'Invoice',
    //   path: '/invoices/invoice/:id',
    //   component: require('../views/finances/Invoice.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   name: 'InvoiceV2',
    //   path: '/invoices/V2/invoice/:id',
    //   component: require('../views/finances/V2/Invoice.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      name: 'Services Cards',
      path: '/finances/services_cards',
      component: require('../views/finances/ServicesCards.vue')
    },
    {
      name: 'Login',
      path: '/login',
      component: require('../views/login/Index.vue')
    },
    // {
    //   name: 'Account',
    //   path: '/account',
    //   component: require('../views/users/NewAccount.vue')
    // },
    {
      name: 'Forgot',
      path: '/forgot',
      component: require('../views/users/Forgot.vue')
    },
    {
      name: 'Reset',
      path: '/reset_password',
      component: require('../views/users/Reset.vue')
    },
    ...generateRoutesFromMenu(menu),
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js